import styled from 'styled-components';

import { sideBarWidthOpen } from 'components/AuthLayout/styled';
import { Color } from 'modules/styles/colors';
import { Spacing } from 'modules/styles/variables';
import { MuiBox, MuiTypography } from 'theme/material-ui';

export const StyledMuiBox = styled(MuiBox)`
  background-color: ${Color.tealLight};
  text-align: center;
  width: ${sideBarWidthOpen}px;
  padding: ${Spacing.small}px ${Spacing.medium}px;
`;

export const StyledMuiTypography = styled(MuiTypography)`
  color: ${Color.black};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
